import React from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import { WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';

/**
 * ExpirationDate Component
 * Renderizza una data di scadenza con stile warning se mancano <= 15 giorni
 * o rosso se la data è scaduta
 * 
 * @param {string} date - Data di scadenza in formato ISO
 * @param {string} format - Formato di visualizzazione (default: 'DD/MM/YYYY')
 */
function ExpirationDate({ date, format = 'DD/MM/YYYY' }) {
  if (!date) return <span>-</span>;

  const expDate = dayjs(date);
  const today = dayjs();
  const daysLeft = expDate.diff(today, 'day');

  // Scaduto (rosso)
  if (daysLeft < 0) {
    return (
      <Tag color="error" icon={<CloseCircleOutlined />}>
        {expDate.format(format)} (scaduto)
      </Tag>
    );
  }

  // In scadenza entro 15 giorni (warning giallo/arancione)
  if (daysLeft <= 15) {
    return (
      <Tag color="warning" icon={<WarningOutlined />}>
        {expDate.format(format)} ({daysLeft} {daysLeft === 1 ? 'giorno' : 'giorni'})
      </Tag>
    );
  }

  // Data normale
  return <span>{expDate.format(format)}</span>;
}

export default ExpirationDate;
